/* unplugin-vue-components disabled */import { render } from "./DetailPlatform.vue?vue&type=template&id=9b7d5daa&scoped=true&ts=true"
import script from "./DetailPlatform.vue?vue&type=script&lang=ts"
export * from "./DetailPlatform.vue?vue&type=script&lang=ts"

import "./DetailPlatform.vue?vue&type=style&index=0&id=9b7d5daa&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9b7d5daa"]])

export default __exports__